// ############################################## espace Admin && instructeur

import {
    DossierDetailType,
    DossierStatusEnum,
    EstablishmentStatus,
} from "../../../../types";
import { getEstablishmentStatusById } from "../../utils";

export function wattingForAssigned(dossierDetail: DossierDetailType) {
    return !dossierDetail.assignedUser;
}

export function sendedToValidate(dossierDetail: DossierDetailType) {
    return (
        // dossierDetail.processedAt &&
        dossierDetail.dossierStatus.code === DossierStatusEnum.ATTENTE_DECISION
    );
}

export function getInstructorReview(dossierDetail: DossierDetailType) {
    return !dossierDetail.assignedUserOpinion ? "Défavorable" : "Favorable";
}

export function getValidatorDecision(
    dossierDetail: DossierDetailType,
    establishmentStatus: EstablishmentStatus[]
) {
    if (dossierDetail.establishmentStatus) {
        return getEstablishmentStatusById(
            dossierDetail.establishmentStatus,
            establishmentStatus
        );
    }
}

export function getInstructorAssignedOfDossier(
    dossierDetail: DossierDetailType
) {
    return dossierDetail.assignedUser;
}
